import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  AssetRecoveryCase,
  AssetRecoveryReport,
  AssetRecoverySummaryReport,
  CreateAssetRecoveryReportRequest,
  CreateAssetRecoveryReportResponse,
  HasItems,
} from '../types';
import { ShareReportRequest } from '../types/reports';

@Injectable({
  providedIn: 'root',
})
export class AssetRecoveryService {
  apiHost = `${environment.apiBaseUrl}`;
  private httpClient = inject(HttpClient);

  getAssetRecoveryCasesForLocation(locationId: number, caseDateFrom: Date, caseDateTo: Date): Observable<HasItems<AssetRecoveryCase>> {
    const params = new HttpParams()
      .append('case_date_from', DateTime.fromJSDate(caseDateFrom).toFormat('yyyy-MM-dd'))
      .append('case_date_to', DateTime.fromJSDate(caseDateTo).toFormat('yyyy-MM-dd'));
    return this.httpClient.get<HasItems<AssetRecoveryCase>>(`${this.apiHost}/Locations/${locationId}/AssetRecoveries`, {
      params,
    });
  }

  createAssetRecoveryReport(locationId: number, request: CreateAssetRecoveryReportRequest): Observable<CreateAssetRecoveryReportResponse> {
    return this.httpClient.post<CreateAssetRecoveryReportResponse>(`${this.apiHost}/Locations/${locationId}/AssetRecoveries`, request);
  }

  getAssetRecoverySummaryForCase(locationId: number, caseId: string): Observable<HasItems<AssetRecoverySummaryReport>> {
    return this.httpClient.get<HasItems<AssetRecoverySummaryReport>>(
      `${this.apiHost}/Locations/${locationId}/AssetRecoveries/Cases/${caseId}/Summary`,
    );
  }

  getAssetRecoveryReportById(assetRecoveryId: string): Observable<AssetRecoveryReport> {
    return this.httpClient.get<AssetRecoveryReport>(`${this.apiHost}/AssetRecoveries/${assetRecoveryId}`);
  }

  shareAssetRecoveryReport(assetRecoveryId: string, request: ShareReportRequest): Observable<void> {
    return this.httpClient.post<void>(`${this.apiHost}/AssetRecoveries/${assetRecoveryId}/Share`, request);
  }

  updateAssetRecoveryInvoice(assetRecoveryId: string, addedFees: number): Observable<void> {
    return this.httpClient.patch<void>(`${this.apiHost}/AssetRecoveries/${assetRecoveryId}/Invoice`, { added_fees: addedFees });
  }
}
